import React from 'react'
import { useCart } from '../../context/CartContext'
import Navbar from '../Navbar';
import Navbar2 from '../Navbar2';
import { Link, useNavigate } from 'react-router-dom';
import './CartScreen.css';
import Footer from '../Footer/Footer';

function CartScreen() {

    const { cartItems, addToCart, removeFromCart, cartTotal } = useCart();
    const navigate = useNavigate();


    return (
        <>
            <Navbar />
            <div className="sticky-navbar">
                <Navbar2 />
            </div>

            <div className="cart-screen container py-5">
                <h2 className="mb-4">Your Cart</h2>

                {cartItems.length === 0 ? (
                    <div className="empty-cart text-center">
                        <h4>Your cart is empty</h4>
                        <Link to='/' className='btn btn-primary mt-3'>
                            Continue Shopping
                        </Link>
                    </div>
                ) : (
                    <>
                        <div className="cart-items">
                            {cartItems.map(item => (
                                <div className="cart-item row mb-4" key={item._id}>
                                    <div className="col-md-2">
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="img-fluid cart-item-image"
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <h5>{item.title}</h5>
                                        <p>₹{item.price}</p>
                                        {item.quantity && (
                                            <p className="text-muted small">
                                                {item.quantity > 10 ? 'In Stock' : `Only ${item.quantity} left`}
                                            </p>
                                        )}
                                    </div>

                                    <div className="col-md-4">
                                        <div className="quantity-control d-flex align-items-center">
                                            <button
                                                className="btn btn-outline-secondary"
                                                onClick={() => removeFromCart(item._id)}
                                            >-</button>
                                            <span className="mx-3">{item.quantity}</span>
                                            <button
                                                className="btn btn-outline-secondary"
                                                onClick={() => addToCart(item)}
                                                disabled={item.quantity >= (item.stock || 0)}
                                            >+</button>
                                        </div>
                                        <div className="mt-2">
                                            <strong>Total: ₹{(item.price * item.quantity).toFixed(2)}</strong>
                                            {item.stock && (
                                                <div className="text-muted small">
                                                    Max: {item.stock} available
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="cart-summary">
                            <div
                                className="d-flex justify-content-between">
                                <h4>Total:</h4>
                                <h4>₹{cartTotal.toFixed(2)}</h4>
                            </div>
                            <button
                                className="btn btn-primary btn-lg w-100 mt-3"
                                onClick={() => navigate('/checkout/address')}
                            >
                                Proceed to Checkout
                            </button>
                        </div>
                    </>
                )}
            </div>

            <Footer />
        </>
    )
}

export default CartScreen